import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Registers acqua's custom typography and radius scales with tailwind-merge
 * so consumer overrides replace the corresponding default utilities.
 *
 * Without this, `cn('text-h4', 'text-surface-title-50')` would drop one of
 * them because twMerge defaults treat anything starting with `text-` as a
 * single group when it doesn't recognize the value.
 */
const twMerge = extendTailwindMerge({
  cacheSize: 2000,
  extend: {
    theme: {
      radius: ['button-sm', 'button-md', 'button-lg']
    },
    classGroups: {
      'font-size': [
        {
          text: [
            'h1',
            'h2',
            'h3',
            'h4',
            'title-xl',
            'title-lg',
            'body-xl',
            'body-lg',
            'body-md',
            'caption-lg',
            'caption-md',
            'caption-sm',
            'control-xs',
            'control-sm',
            'control-md',
            'control-lg'
          ]
        }
      ]
    }
  }
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
